import { Injectable } from '@angular/core';
import { Usuario } from "@tivic-team/manager-ts/dist/seg/entities/usuario.entity";
import { LoaderService } from 'app/services/loader.service';
import { HttpPost, HttpResponse, JSONData, Quark, Url } from 'sol-request-angular/dist/comunicacao';
import { environment } from 'src/environments/environment';

@Injectable()
export class LoginController {

    constructor(private _loaderService:LoaderService) { }

    async login(login:string, senha:string): Promise<Usuario> {

        this._loaderService.show();

        let quark = new Quark(
            new HttpPost({
                url: new Url({
                    id: 'login',
                    environment: environment
                }),
                data: new JSONData({usuario: login, senha: senha, modulo: null})
            }),
            new HttpResponse(
                new Usuario()
            )
        );
        
        return await quark.call().finally(() => {
            this._loaderService.hide();
        });
    }


    async logout (usuario: string) {
        this._loaderService.show();

        let quark = new Quark (
            new HttpPost ({
                url: new Url ({
                    id: 'mob/logout',
                    environment: environment
                }),
                data: new JSONData({usuario: usuario})
            }),
            new HttpResponse(
                new Number()
            )
        );

        return await quark.call().finally(() => {
            this._loaderService.hide();
        });

    }
}
